<template lang="pug">
	.templates-list(:style="{height: `calc(100% - ${Layout.headerHeight}px)`, top: `${Layout.headerHeight}px`}")
		.templates-list-inner
			.template(v-for="template in Metadata.Templates" :key="template.id")
				.template-icon(v-bind:class="{selected: Template.SelectedTemplate.id === template.id}" v-bind:style="{ backgroundImage: `url(/templates/${('00' + template.id).slice(-3)}-${template.codename}/icon.png)` }" v-on:click="Template.selectTemplate(template.id)")
</template>

<script>
	import Screen from './../../mixins/screen';

	import { User } from './../../services/User'
	import { Metadata } from './../../services/Metadata'
	import { Template } from './../../services/Template'
	import { Layout } from './../../services/Layout'

	import SetupSettings from "./../../settings/settings.json";

	export default {
		name: 'TemplateList',
		mixins: [Screen],
		screen: {
			updateOn: ["Template Changed", "Selected Template Changed"]
		},
		components: {},
		data() {

			this.Metadata = Metadata;
			this.Layout = Layout;
			this.Template = Template;

			this.SetupSettings = SetupSettings;

			return {
				showed: true
			};
		},
		methods: {
			collectData() {

			}
		}
	}
</script>

<style lang="sass">

	.templates-list
		width: 50px
		height: 100%
		text-align: center
		background-color: #343b41
		border-right: 1px solid #23282c
		position: absolute
		left: 0
		top: 0
		overflow: hidden

		.templates-list-inner
			overflow-y: auto
			width: 100px
			height: 100%

		.template
			width: 48px
			height: 48px
			display: flex
			align-items: center
			justify-content: center

			.template-icon
				background: center / 100% no-repeat
				width: 35px
				height: 35px
				cursor: pointer
				border-radius: 10px
				border: 2px solid transparent

				&.selected
					border: 2px solid cornsilk
					border-radius: 3px

</style>

